import endpoints from 'config/endpoints';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';

import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';

const MONTHS_START = 1;

module.exports = storeModuleFactory({
    name:            'reportingLast2MonthsBackups',
    endpoint:        endpoints.reportingBackupsMonthlyAggr.endpoint,
    timeout:         TIMEOUT_STORE.TIMEOUT_STORE_BIG,
    filterParamsMap: {
        startDate: 'start_date',
        endDate:   'end_date'
    },
    parseParameters: parameters => {
        const startDate = new Date(parameters.startDate);
        const endDate = new Date(parameters.endDate);

        startDate.setMonth(endDate.getMonth() - MONTHS_START);

        return {
            start_date: Math.floor(startDate / TIMESTAMP_MULTIPLY),
            end_date:   Math.floor(endDate / TIMESTAMP_MULTIPLY)
        };
    },
    transformResultsFn:  json => json,
    transformEntitiesFn: item => ({
        date:       item.date * TIMESTAMP_MULTIPLY,
        backupSize: item.backup_size
    })
});



// WEBPACK FOOTER //
// ./src/modules/store/reportingLast2MonthsBackups.js